// This file exports an array of strings
export default [
    "Andrea Marcela Rincón Caicedo",
          "Zareth Alexandra Correa Calderón",
          "Paola Andrea Rivera Penagos",
          "Felipe Arturo Lemus Ramos",
          "Marcela Andrea Zuleta Murgas",
          "Paula Marcela Cardona Ruiz",
          "Lady Andrea Chavarro Velásquez",
          "Luis Fernando Ucros Velásquez",
          "Diana Carolina Montana Bernal",
          "Paola Moreno Chavarría",
          "Zulma Constanza Guauque Becerra",
          "Ingrid Carolina Ariza Cristancho",
          "Jose Luis Santaella Bermúdez",
          "Angélica María Angarita Martínez",
          "Ronald Augusto Osorio Martínez",
          "Silencio Administrativo",
          "Dalia Teresa Gamboa Naranjo",
          "Imposibilidad",
          "Silvia Janeth Cortés Jaramillo",
          "Isabel Cristina Martínez Mendoza",
          "Doris Patarroyo Patarroyo",
          "Dalia Teresa Gamboa Naranjo",
          "María Del Pilar Hernández Bárcenas",
          "Malky Katrina Ferro Ahcar",
          "Sandra Herrera Hernández",
          "Juana Masiel Sabogal Ardila",
          "Freddy Alexander Bernal Ruiz",
          "Luz Adriana Loaiza Sandoval",
          "Luis Gabriel Reyes Escobar",
          "Sonia Judith Mendoza Góngora",
          "Miriam Del Socorro Bustamante Salazar",
          "Angela Johanna Molina Canon",
          "Jairo Franco Sánchez",
          "Gabriel Luna Racines",
          "Javier Andrés Hernández Rojas",
          "Claudia Lorena Orozco González",
          "Jenny Marcela Vizcaino Jara",
          "María Gregoria Vásquez Correa",
          "Lida Constanza Rojas Cáceres",
          "Nancy Yazmin Ortiz Barrero",
          "Luis Gabriel Arbeláez Marín",
          "Hernando Blanco Manchola",
          "Tomas Joaquín Reyes Millán",
          "Rosa Mercedes Niño Amaya",
          "No Registra",
          "Mayer Lucero Castaño García",
          "Liliana Yaneth Castaño Alzate",
          "Constanza Nieto Leal",
          "Yeison Alexander Mesa Soler",
          "Javier Jose Vergara Campos",
          "Lina Zuluaga",
          "Mónica Liliana Torres Bernal",
          "Luis Fernando Prieto Rodríguez",
          "Claudia Patricia Villamizar",
          "Claudia Elena Baena Restrepo",
          "Reynaldo Ramírez Restrepo",
          "Jose Diego Tafurth Masso",
          "Ismenia María Montealegre Gutiérrez",
          "Gustavo Gómez Mateus",
          "Maritza Barrera Archila",
          "Diego Alberto Vargas Gómez",
          "Celia Regina Zúñiga",
          "Luz Aida Álvarez Bedoya",
          "Ana María Ruiz Mejía",
          "Jose Vicente Espinosa Jiménez",
          "Pablo Emilio Martínez Aparicio",
          "Jairo E. Beltrán",
          "Claudia Susana Bernal",
          "Diego Alejandro Rodríguez Linares",
          "Héctor Eduardo Patiño Jiménez",
          "Fernando Jose Velasco",
          "María Amalia Cruz Martínez",
          "Elba María Usta",
          "Carolina Romero Barragán",
          "Libinton Brayan Rivas",
          "Lady Diana Casanova Libreros",
          "María Ofelia Lasprilla Olmedo",
          "Luz Cubides Peña",
          "Luz Marina Bolaños",
          "Lina María Aramburo Hernández",
          "Leydi Johanna Ayala Marín",
          "Libinton Brayan Rivas"
  ];


// WEBPACK FOOTER //
// ./src/components/contractWizards/auxFiles/presuntosResponsable.js